var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImg6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 75,
    viewBox: "0 0 80 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 79.2253,
    height: 75,
    rx: 14,
    fill: "#5A47AB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.4807 59C46.5195 59 49.9075 58.149 52.6448 56.447C55.4011 54.7449 57.478 52.4118 58.8753 49.4476C60.2918 46.4643 61 43.0889 61 39.3216C61 39.1494 60.9904 38.8052 60.9713 38.2889C60.9521 37.7534 60.9234 37.2849 60.8852 36.8833L9 38.9333L55.4873 41.1001C55.181 45.2117 53.9751 48.4149 51.8695 50.7098C49.7831 53.0047 46.7396 54.1425 42.7391 54.1234C39.6573 54.1043 37.0828 53.3967 35.0155 52.0007C32.9674 50.6046 31.4265 48.6636 30.3928 46.1775C29.3592 43.6722 28.852 40.775 28.8711 37.4857C28.8902 34.1772 29.4071 31.28 30.4216 28.7939C31.4552 26.2886 32.9961 24.338 35.0442 22.942C37.0923 21.5459 39.6573 20.8575 42.7391 20.8766C45.6869 20.8957 48.137 21.6511 50.0894 23.1428C52.0609 24.6153 53.487 26.6042 54.3675 29.1094L60.9999 31.7667C59.928 28.0566 56.5113 21.4025 53.6784 19.2415C50.8455 17.0805 47.1129 16 42.4807 16C38.6332 16 35.2835 16.8797 32.4314 18.6391C29.5793 20.3794 27.3685 22.8559 25.7989 26.0687C24.2293 29.2815 23.4445 33.0872 23.4445 37.4857C23.4445 41.9224 24.2389 45.7472 25.8276 48.96C27.4164 52.1728 29.6368 54.6493 32.4888 56.3896C35.36 58.1299 38.6907 59 42.4807 59Z",
    fill: "#FBD15B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImg6);
export default __webpack_public_path__ + "static/media/Img6.097f2eb18e80212c7d139ae39ade37ff.svg";
export { ForwardRef as ReactComponent };